import { LinearProgress, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { CalculatorRateBar as CalculatorRateBarType } from "web_myplann/Calculators/Types/CalculatorRateBar";
import { getRateBarTone } from "web_myplann/Calculators/Utils/getRateBarTone";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { formatRate } from "web_myplann/Shared/Utils/percentageFormatters";

type Props = {
	bar: CalculatorRateBarType;
	maxRate: number;
	isSubtle: boolean;
};

export const CalculatorRateBar: FC<Props> = ({ bar, maxRate, isSubtle }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<>
			<Typography variant="caption" color={theme.palette.grey[600]}>
				{bar.label}
			</Typography>
			{bar.note ? (
				<Typography
					variant="caption"
					color={theme.palette.grey[500]}
					gridColumn="span 2"
				>
					{bar.note}
				</Typography>
			) : (
				<>
					<LinearProgress
						variant="determinate"
						value={bar.rate === undefined ? 0 : (bar.rate / maxRate) * 100}
						sx={theme.rateBar[getRateBarTone(bar.isEmphasized, isSubtle)]}
					/>
					<Typography
						variant="button"
						color="text.primary"
						tabular
						textAlign="right"
					>
						{t(
							bar.isFromRate
								? Resources.Calculators.Result.RateValueFrom
								: Resources.Calculators.Result.RateValue,
							{ rate: formatRate(bar.rate ?? 0) },
						)}
					</Typography>
				</>
			)}
		</>
	);
};
